<router-outlet />
<!-- <div class="background"></div> -->
<!-- <button (click)="addTestToast()">Add test toast</button> -->
<div class="toasts">
  <app-toast />
</div>